import styled from 'styled-components';
import { size } from 'polished';
import { zIndex } from '../../../styles/zIndex';
import { MediaQuery } from '../../../styles/mediaQuery';
import { respondTo } from '../../../styles/helpers/respondTo';
import { pseudo } from '../../../styles/helpers/pseudo';
import { Ease } from '../../../styles/easing';
import { FontSize, FontWeight, TransitionDuration } from '../../../styles/variables';
import { hover } from '../../../styles/helpers/hover';

export const StyledInsetMap = styled.div<{ 'data-reverse'?: boolean; $routeActive: boolean }>`
  position: absolute;
  bottom: 36.5625rem;
  left: ${(props) => (props['data-reverse'] ? '1.25rem' : 'calc(1.25rem + 26.25rem)')};
  filter: drop-shadow(0px 0px 20px rgba(48, 76, 178, 0.05));
  border-radius: ${({ theme }) => theme.defaultCssProps.borderRadius.normal};
  overflow: hidden;
  z-index: ${zIndex('overlay')};
  img {
    top: 0.125rem;
    border: 2px solid ${({ theme }) => theme.color.white};
  }

  @media ${respondTo(MediaQuery.Medium)} {
    ${size('7.6875rem', '12.5rem')};
    bottom: 36.5625rem;
    ${({ $routeActive }) =>
      $routeActive &&
      `
      ${size('6.4375rem', '10rem')};
      bottom: 50.5rem;
    `}
  }
  @media ${respondTo(MediaQuery.Large)} {
    ${size('10rem', '16.25rem')};
    bottom: 1.875rem;
  }
`;

type StyledClusterNumberProps = {
  $isConnected?: boolean;
  $isUnserved?: boolean;
};

export const StyledClusterNumber = styled.div<StyledClusterNumberProps>`
  cursor: pointer;
  font-size: ${FontSize.Normal};
  font-weight: ${FontWeight.Bold};
  color: ${({ theme }) => theme.color.white};
  margin-top: 3.0625rem;
  margin-left: 7.7125rem;
  position: absolute;
  z-index: ${zIndex('map-overlay')};
  transition: transform ${TransitionDuration.Slow} ${Ease.EaseOutBack};

  &::before {
    ${pseudo()};
    ${size('2.9375rem')}
    position: absolute;
    z-index: -1;
    cursor: pointer;
    bottom: -2.0625rem;
    left: 0.3125rem;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.color.clusterBlue};
    transform: translate(-50%, -50%);
    transition: transform ${TransitionDuration.Slow} ${Ease.EaseOutBack};
  }
  ${hover(`
    transform: translate(-0%, -8%);
    &::after {
      transform: translate(-50%, -50%);
    }
  `)}

  ${({ $isConnected, theme }) =>
    !$isConnected &&
    `
     color: ${theme.color.blue};

    &::before {
      border: 2px solid ${theme.color.blue};
      background-color: ${theme.color.white};
    }
  `}

${({ $isUnserved, $isConnected, theme }) =>
    $isUnserved &&
    !$isConnected &&
    `
    cursor: not-allowed;
    color: ${theme.color.blue};

    &::before {
      cursor: not-allowed;
      border: transparent;
      background-color: ${theme.color.lighterGrey};
  }
  `}

  @media ${respondTo(MediaQuery.Medium)} {
    font-size: ${FontSize.Normal};
    height: 1.6875rem;
    margin-left: 50%;
    &::before {
      ${size('1.375rem')};
      bottom: -0.1875rem;
    }
    @media ${respondTo(MediaQuery.Large)} {
      font-size: ${FontSize.Large};
      height: 3.4375rem;
      margin-left: 50%;
      &::before {
        ${size('2.9375rem')};
        bottom: -0.3125rem;
        left: 0.4375rem;
      }
    }
  }
`;
